import React from "react";
import i18n from "i18n";

import Step from "components/MainApp/atoms/Wizard/Step";
import renderInput from "helpers/FormGenerator";

import styles from "./PrepOrders.LoadPrepOrders.step1.module.scss";

export const PrepOrderStep1 = ({
  handleChange,
  handleSelect,
  fields
}) => {


  const stepContent = (
    <div className={styles["prep-order-step-one-content"]}>
      {fields && fields.map(field => {
        return renderInput(field, handleSelect, handleChange, "prep-order-field")
      })}
    </div>
  );
  return (
    <div className={styles["prep-order-step-one-container"]}>
      <Step title={i18n.t("enter.order.details")} content={stepContent} paddingVariant="orders-padding"></Step>
    </div>
  );
};

export default PrepOrderStep1;
